import { createAction } from 'typesafe-actions';

export const UPDATE_SELECTEDYOGACENTERANDDATE = 'selectedYogaCenterAndDate/UPDATE_SELECTEDYOGACENTERANDDATE';

export const getSelectedYogaCenteAndDaterAsync = createAction(UPDATE_SELECTEDYOGACENTERANDDATE, ({ ...parameters }) => ({ ...parameters }))()


